import AOS from 'aos';

import header from './components/header';
import invest from './components/invest';
import discussion from './components/discussion';
import speakers from './components/speakers';
import lastBlock from './components/last';
import {initTimer} from './components/timer';
import timerData from './components/timer-data';
import {initTopBlock} from './components/top-block';
import menu from './components/menu';

let $container = $('.site-container');
let $page = $('.page');
let $html = $(document.documentElement);
let $pageMain = $('.page.main');

window.AOS = AOS;

history.scrollRestoration = 'manual';

function scrollToOnLoad() {
	if (!location.hash) {
		return;
	}

	menu.scrollToElement(location.hash);
}

const animateOnDesktop = (tl) => {
	tl
		.from($container, 0.7, {
			autoAlpha: 0,
			clearProps: 'all',
		})
		.from($('.top-block__decoration--1'), 0.7, {
			autoAlpha: 0,
			x: 80,
			clearProps: 'all',
		})
		.from($('.header'), 0.4, {
			autoAlpha: 0,
			y: -50,
			clearProps: 'all',
		}, 0.7)
		.from($('.business-img'), 0.4, {
			autoAlpha: 0,
			y: 50,
			clearProps: 'all',
		})
		.from($('.top-block__title'), 0.4, {
			autoAlpha: 0,
			y: 50,
			clearProps: 'all',
		})
		.from($('.top-block__date-wrap'), 0.4, {
			autoAlpha: 0,
			y: 50,
			clearProps: 'all',
		})
		.from($('.top-block__date'), 0.4, {
			autoAlpha: 0,
			y: 50,
			clearProps: 'all',
		})
		.from($('.video, .announcement'), 0.4, {
			autoAlpha: 0,
			y: 50,
			clearProps: 'all',
		});
};

const animateOnMobile = (tl) => {
	tl.from($container, 1, {
		opacity: 0,
		clearProps: 'all',
	});
};

export function showMain() {
	return new Promise((resolve) => {
		let tl = new TimelineMax({
			onStart() {
				$html
					.data('page', 'main')
					.attr('data-page', 'main');

				initTimer(timerData.main, $pageMain);

				$container.removeClass('is-hidden');
				$pageMain.removeClass('is-hidden');
				$('[data-aos]').removeClass('aos-animate');

				AOS.init({
					offset: 60,
					duration: 700,
					delay: 60,
					once: true,
					disable: innerWidth <= 1024,
				});

				speakers.initSlider($pageMain);
				invest.initSlider($pageMain);
				discussion.initSlider($pageMain);
				lastBlock.initSlider($pageMain);
				initTopBlock($pageMain);

				window.scrollTo(0, 0);
			},
			onComplete() {
				header.init();

				scrollToOnLoad();
			},
		});

		if ($(window).width() > 1024) {
			animateOnDesktop(tl);
		} else {
			animateOnMobile(tl);
		}

		resolve();
	});
}

export function showArticle(id) {
	return new Promise((resolve) => {
		let $currentPage = $(`.page.article[data-article="${id}"]`);

		let tl = new TimelineMax({
			onStart() {
				initTimer(timerData[`article${id}`], $currentPage);

				$html
					.data('page', `article--${id}`)
					.attr('data-page', `article--${id}`);

				$container.removeClass('is-hidden');
				$currentPage.removeClass('is-hidden');
				$('[data-aos]').removeClass('aos-animate');

				speakers.initSlider($currentPage);
				invest.initSlider($currentPage);
				discussion.initSlider($currentPage);
				lastBlock.initSlider($currentPage);
				initTopBlock($currentPage);

				AOS.init({
					offset: 60,
					duration: 700,
					delay: 60,
					once: true,
					disable: innerWidth <= 1024,
				});

				window.scrollTo(0, 0);
			},
			onComplete() {
				header.init();

				scrollToOnLoad();
			},
		});

		if (innerWidth > 1024) {
			animateOnDesktop(tl);
		} else {
			animateOnMobile(tl);
		}

		resolve();
	});
}

export function pageTransition(animation, id) {
	return new Promise((resolve) => {
		new TimelineMax({
			onComplete() {
				$container.addClass('is-hidden');
				$page.addClass('is-hidden');
				$(document.documentElement).removeAttr('style');
				header.deactivate();
				$('[data-aos]').removeClass('aos-animate');

				TweenMax.set([$container], {clearProps: 'all'});
				animation(id);
			},
		})
			.to($container, 0.7, {
				autoAlpha: 0,
			});

		resolve();
	});
}
